// Pattern: docs/design-patterns/frontend/api-client — service layer (no error catching)

import type { RefArchDetail, RefArchManifest } from '~/types';

import { apiRequest } from './client';

const REF_ARCH_BASE = '/reference-architectures';

export async function getRefArch(id: string): Promise<RefArchDetail> {
  const response = await apiRequest<RefArchDetail>(`${REF_ARCH_BASE}/${id}`);
  return response.data;
}

export async function getRefArchContext(): Promise<{
  architecture_types: string[];
  variants: Record<
    string,
    Array<{
      brownfield_indicators: string[];
      description: string;
      ref_arch_id: string;
      tags: string[];
      variant: string;
    }>
  >;
}> {
  const response = await apiRequest<{
    architecture_types: string[];
    variants: Record<
      string,
      Array<{
        brownfield_indicators: string[];
        description: string;
        ref_arch_id: string;
        tags: string[];
        variant: string;
      }>
    >;
  }>(`${REF_ARCH_BASE}/context`);
  return response.data;
}

export async function getRefArchManifest(): Promise<RefArchManifest> {
  const response = await apiRequest<RefArchManifest>(`${REF_ARCH_BASE}/manifest`);
  return response.data;
}
